/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { GET_PLANS_BY_CGP } from '../../../../SharedModules/services/service';
import { redirectURLLink } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  dispatchgetPlansByCgp,
  getAllContactType,
  getExistingContactDetails,
} from '../../Plan/store/actions';
import { setTabValue } from '../../client/store/actions';

export const getPlansByCgp = (value, dispatch, callBack) => {
  axios
    .post(GET_PLANS_BY_CGP, value)
    .then((response) => {
      const data = response?.data?.data;
      dispatch(dispatchgetPlansByCgp(data));

      callBack(data && Object.keys(data).length > 0 ? data : null);
    })
    .catch(() => {});
};

const MaintainGroupPlanCustomNaviation = ({ column, data }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  return (
    <div style={{ height: 'max-content' }}>
      <span
        style={{
          cursor: 'pointer',
          color: 'blue',
          textDecoration: 'underline',
        }}
        onClick={() => {
          if (column.colId === 'cgpId.planId') {
            const obj = {
              clientId: data.cgpId.clientId,
              groupId: data.cgpId.groupId,
              planId: data.cgpId.planId,
              planName: data.planName,
            };
            getPlansByCgp(obj, dispatch, (res) => {
              redirectURLLink(
                '/createNewPlan',
                'Maintain Plan',
                history,
                dispatch
              );
            });
          } else {
            window.localStorage.setItem('clientSearchOrAdd', 'search');
            const clientId = data && data.cgpId && data.cgpId.clientId;
            window.localStorage.setItem('clientId', clientId);
            dispatch(setTabValue(0));
            redirectURLLink('/maintain', 'Maintain Client', history, dispatch);
          }
        }}
      >
        {column.colId === 'cgpId.planId'
          ? data && data.cgpId && data.cgpId.planId
          : 'Client'}
      </span>
    </div>
  );
};

export default MaintainGroupPlanCustomNaviation;
